import { render, staticRenderFns } from "./AddressModal.vue?vue&type=template&id=04ca2356&scoped=true&"
import script from "./AddressModal.vue?vue&type=script&lang=js&"
export * from "./AddressModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressModal.vue?vue&type=style&index=0&id=04ca2356&prod&lang=scss&"
import style1 from "./AddressModal.vue?vue&type=style&index=1&id=04ca2356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca2356",
  null
  
)

export default component.exports